import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SupplierCapabilityAuditDTO } from '../../interfaces/capability-audit/supplier-capability-audit.dto.interface';

@Injectable({ providedIn: 'root' })
export class CapabilityAuditService {
  baseUrl = '/api/supplier-capability-audit';

  constructor(public http: HttpClient) {}

  public getAudits(organisationId: number): Promise<SupplierCapabilityAuditDTO[]> {
    return this.http
      .get<SupplierCapabilityAuditDTO[]>(`${this.baseUrl}/${organisationId}`)
      .toPromise();
  }
}
